module.exports = __webpack_public_path__ + "img/down.7fb6aaea.svg";